module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-exclamation"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Suggested address")]), _vm._v(" "), _c('p', {
    staticClass: "modal-subtitle"
  }, [_vm._v("We’ve found the following address given the details you provided:")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v(" " + _vm._s(_vm.suggestedAddress.streetAddress1)), _c('br'), _vm._v(" "), (_vm.suggestedAddress.streetAddress2) ? _c('span', [_vm._v(_vm._s(_vm.suggestedAddress.streetAddress2) + " "), _c('br')]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.suggestedAddress.city) + ", " + _vm._s(_vm.suggestedAddress.state) + " " + _vm._s(_vm.suggestedAddress.zipCode) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('p', [_vm._v("Would you like to accept or edit the address?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Go back to edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.acceptSuggestion()
      }
    }
  }, [_vm._v("Accept suggestion")])])])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78801dd1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddressSuggestion.vue
// module id = 2179
// module chunks = 1